import {NgModule} from '@angular/core';
import {StoreModule} from '@ngrx/store';
import {authReducer} from './reducers/auth.reducer';
import {Features} from '../Features';

@NgModule({
  declarations: [],
  imports: [
    StoreModule.forFeature(Features.AUTH, authReducer),
  ],
})
export class AuthStoreModule {
}
